import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/Login.context'
const ProtectedRouters:React.FC = () => {
    const isAuth = useAuth()
    return<>
        {isAuth.isAuth ? <Outlet/> : <Navigate to={'/login'} />}
    </>
}
export default ProtectedRouters